<template>
<div id="model-scene">
  <ul class="scene-list" ref="sceneList" @mousewheel="scrollBar">
    <div class="scene-item-box" ref="sceneItemBox">
      <div ref="draggableBox" class="draggable-box" v-if="!editor">
        <li ref='sceneItem' class="scene-item" v-for="(item,index) in data" :key="'scene'+index" @click="changeScene(index,$event)">
          <div class="scene-item-top">
            <img ref='sceneImage' :src="item.view_cover_face_url" alt="" class="scene-img">
          </div>
          <div class="scene-item-bottom">
            <span class="name">{{item.name}}</span>
          </div>
        </li>
      </div>
      <draggable ref="draggableBox" :list="data" class="draggable-box" v-if="editor" group="site" animation="300" :scroll="true" @end="sortingComplete">
        <div v-for="(item,index) in data" :key="'scene'+index">
          <li ref='sceneItem' class="scene-item">
            <div class="scene-item-top">
              <span class="option-switch" @click="showOption($event)"><i></i><i></i><i></i></span>
              <img ref='sceneImage' :src="item.view_cover_face_url" alt="" class="scene-img">
              <div class="option-box" @click="changeScene(index,$event)" @mouseleave.stop="showOptionSwitch(index)">
                <div class="option" @mouseleave.stop="showOptionSwitch(index)">
                  <i class="iconfont icon-god-editor" @click='showEditorDialog(index)'></i>
                  <i class="iconfont icon-delete" @click.self="deleteScene(index)"></i>
                </div>
              </div>
            </div>
            <div class="scene-item-bottom">
              <span class="name">{{item.name}}</span>
            </div>
          </li>
        </div>
      </draggable>
    </div>
  </ul>
</div>
</template>

<script>
import draggable from 'vuedraggable'
import {
  ViewSet
} from '@/components/modeldemo/View'
import dailog from '@/components/dailog'
import dailogComponent from '@/components/DailogComponent'
import {
  Swiper,
  SwiperSlide,
  directive
} from 'vue-awesome-swiper'
import {
  getPlatform,
} from '@/components/modeldemo/Utils'
import 'swiper/css/swiper.css'
import TWEEN from "tween.js";
import * as Statistic from './Statistic'

export default {
  name: 'modelScene',
  components: {
    draggable,
    dailogComponent,
    Swiper,
    SwiperSlide
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    },
    editor: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      clickpoint: 0,
      sceneStartX: 0,
      sceneEndX: 0,
      moveFlag: false,
      sceneListWidth: 0,
      draggableBoxWidth: 0,
      sceneItem: null,
      sceneItemWidth: 0,
      sceneItemMarginLeft: 0,
      sceneItemMarginRight: 0,
      minOffset: 0,
      maxOffset: 0,
      offset: 0,
      activeDistance: 0
    }
  },
  created() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.initSceneParam();
    });
  },
  methods: {
    initView(viewset) {
      //场景的拖拽移动左右移动效果
      this.$nextTick(()=>{
        this.sceneListWidth = parseInt(document.defaultView.getComputedStyle(document.querySelector('.scene-list'), null).width.split('px')[0]);
        // this.draggableBoxWidth = parseInt(document.defaultView.getComputedStyle(document.querySelector('.draggable-box'), null).width.split('px')[0]);
        const draggableBox = document.querySelector('.draggable-box');
        this.draggableBoxWidth = parseInt(draggableBox.clientWidth);
        window.console.log(this.sceneListWidth + '----' + this.draggableBoxWidth)
        document.querySelector('.scene-item-box').style.width = document.querySelector('.draggable-box').style.width = 'fit-content';
        getPlatform().platform === 'pc' && (document.querySelector('.scene-list').paddingBottom = '5px');

        if (!this.editor) {
          if (getPlatform().platform !=='pc') {
            document.querySelector('.draggable-box').addEventListener('touchstart', this.down, {
              passive: false
            });
          } else {
            document.querySelector('.draggable-box').addEventListener('mousedown', this.down);
          }
        }
        // if (this.sceneListWidth <= this.draggableBoxWidth) {

        // } else document.querySelector('.scene-item-box').style.width = document.querySelector('.draggable-box').style.width = this.editor ? 'auto' : '100%';
      });

      this._viewSet = viewset
      this._viewSet.toSceneViewListener.add(this.activeScene.bind(this));

      const images = document.querySelectorAll('#model-scene img');
      for (let val of images) val.ondragstart = () => false

      // Firefox注册事件
      document.querySelector("#model-scene").firstElementChild.addEventListener('DOMMouseScroll', this.scrollBar, false);

    },
    initSceneParam() {
      this.sceneListWidth = parseInt(document.defaultView.getComputedStyle(document.querySelector('.scene-list'), null).width.split('px')[0]);
      this.draggableBoxWidth = parseInt(document.defaultView.getComputedStyle(document.querySelector('.draggable-box'), null).width.split('px')[0]);

      this.sceneItem = document.querySelectorAll('.scene-item');
      if (this.sceneItem.length !== 0) {
        this.sceneItemWidth = parseInt(document.defaultView.getComputedStyle(this.sceneItem[0], null).width.split('px')[0]);
        this.sceneItemMarginLeft = parseInt(document.defaultView.getComputedStyle(this.sceneItem[0], null).marginLeft.split('px')[0]);
        this.sceneItemMarginRight = parseInt(document.defaultView.getComputedStyle(this.sceneItem[0], null).marginRight.split('px')[0]);
      }

      this.minOffset = this.sceneListWidth / 2;
      this.maxOffset = this.draggableBoxWidth - this.minOffset;
      this.maxOffset < this.minOffset && (this.maxOffset = this.minOffset);

    },
    // 鼠标滚轮控制滚动条
    scrollBar(ev) {
      const step = 50; // 每次滑动距离
      if(ev.deltaY < 0 || ev.detail < 0){ // ev.detail 兼容火狐
          //向上滚动鼠标滚轮，屏幕滚动条左移
          ev.currentTarget.scrollLeft  -= step;
      } else {
          //向下滚动鼠标滚轮，屏幕滚动条右移
          ev.currentTarget.scrollLeft  += step;
      }
    },
    //切换场景
    changeScene(index, e) {
      if (this.moveFlag) return

      if (e.target.className !== 'iconfont icon-god-editor' && e.target.className !== 'iconfont icon-delete') {
        const targetId = this.$props.data[index].view_id;
        Statistic.markInteract(Statistic.InteractType.View)

        this._viewSet.toSceneView(targetId);
        const sceneItems = this.$refs.sceneImage.length;
        for (let i = 0; i < sceneItems; i++) {
          this.$refs.sceneItem[i].setAttribute('class', (index === i)?'scene-item-active':'scene-item');

        }
      }
    },
    //删除场景
    deleteScene(index) {
      // 隐藏option场景操作按钮
      this.showOptionSwitch(index);
      // 执行删除
      if (this.$props.editor) {
        const viewId = this.$props.data[index].view_id;
        this.$http('/api/view/remove', {
          viewId: viewId
        }, "POST").then(res => {
            if (res.data.status===200) {
              if (this.$parent.scene = removeScene(this.$props.data, index)) {
                this.$Message.success('场景删除成功');
                setTimeout(()=>{
                  !this._viewSet.deleteSceneView(viewId) && dailog.show('icon-sad', '场景删除失败');
                }, 1500);
              }
            }
          }).catch(err => {
            window.console.error(err);
          });
      }

      function removeScene(scene, index) {
        scene.splice(index, 1);
        return scene;
      }
    },
    //修改场景名称
    showEditorDialog(index) {
      this.$emit('modify', index);
    },
    // 鼠标按下添加注册鼠标移动和鼠标抬起事件
    down(e) {
      this.moveFlag = true;
      if (getPlatform().platform !=='pc' || window.screen.width <= 768) {
        this.sceneStartX = e.touches ? e.touches[0].clientX : e.clientX;
      } else {
        this.sceneStartX = e.clientX;
      }

      this.clickpoint = this.sceneEndX = this.sceneStartX;

      document.addEventListener('touchmove', this.getDistance);
      document.addEventListener('touchend', this.up);
      document.addEventListener('mousemove', this.getDistance);
      document.addEventListener('mouseup', this.up);
    },
    //获取鼠标移动距离
    getDistance(e) {
      if (getPlatform().platform !=='pc' || window.screen.width <= 768) {
        this.sceneEndX = e.touches ? e.touches[0].clientX : e.clientX;
      } else {
        this.sceneEndX = e.clientX;
        e.preventDefault();
      }
      // 移动
      document.querySelector("#model-scene").firstElementChild.scrollLeft -= this.sceneEndX - this.sceneStartX;
      // 更新起始位置
      this.sceneStartX = this.sceneEndX;
    },
    //鼠标抬起移出鼠标移动和鼠标抬起事件
    up(e) {
      // 没有拖动，标记为执行切换场景
      if (this.sceneEndX === this.clickpoint) this.moveFlag = false;

      document.removeEventListener('mousemove', this.getDistance);
      document.removeEventListener('mouseup', this.up);
      document.removeEventListener('touchmove', this.getDistance);
      document.removeEventListener('touchend', this.up);
    },
    activeScene(id) {
      this.activeDistance = (id + 0.5) * (this.sceneItemWidth + this.sceneItemMarginLeft + this.sceneItemMarginRight);
      if (this.activeDistance > this.minOffset) {
        if (this.activeDistance < this.maxOffset) {
          this.offset = this.activeDistance - this.minOffset;
        } else {
          this.offset = this.maxOffset - this.minOffset;
        }
      } else {
        this.offset = 0;
      }
      document.querySelector("#model-scene").firstElementChild.scrollLeft = this.offset;
      this.$props.data.forEach((value, index) => {
        this.$refs.sceneItem[index].setAttribute('class', (index === id)?'scene-item-active':'scene-item');

      });
    },
    // 点击...展开操作列表
    showOption(e) {
      e.currentTarget.nextElementSibling.nextElementSibling.firstElementChild.style.display = 'block';
      e.currentTarget.nextElementSibling.nextElementSibling.firstElementChild.style.height = '50%';
    },
    // 移出option容器隐藏操作列表
    showOptionSwitch(idx) {
      const oDiv = document.querySelectorAll(".option")[idx];
      oDiv.style.display = 'none';
      oDiv.style.height = '0%';
    },
    // 场景排序
    sortingComplete(evt) {
      const tempArr = [];

      this.$props.data.forEach((item, index) => {
        tempArr.push({
          viewId: item.view_id,
          viewOrderId: index,
          viewModelId: item.view_cover_face_url.split('/')[3]
        });
      })

      this.$http('/api/view/modify', tempArr, "PUT").then(res => {
        if(res.status === 200) {
          this.$Message.success('排序成功');
        }
        // window.console.info(res.data);
      }).catch( err => {
        window.console.error(err);
      })
    }
  },
  computed: {

  },
  beforeDestroy() {

  }
}
</script>

<style scoped>
#model-scene {
  display: flex;
  align-items: center;
  width: calc(100% - 380px);
  height: 141px;
  position: absolute;
  z-index: 99999;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 10px;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: all;
}

.scene-list {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
}

/* 设置滚动条的样式 */
.scene-list::-webkit-scrollbar {
  width: 100%;
  height: 6px;
  margin-top: 4px;
  border-radius: 3px;
}

/* 滚动槽 */
.scene-list::-webkit-scrollbar-track {
  background-color: #333333;
  border-radius: 3px;
}

/* 滚动条滑块 */
.scene-list::-webkit-scrollbar-thumb {
  background-color: #c5c4c3;
}

.draggable-box,
.scene-item-box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
}

.scene-item,
.scene-item-active {
  width: 110px;
  height: 110px;
  font-size: medium;
  margin: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  border: solid 3px rgb(255, 255, 255, 0.4);
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.draggable-box > li:last-child,
.draggable-box > li:last-child .scene-item-active {
  margin: 0;
}

.scene-item-top {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-size: 0;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
}

.scene-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: block;
}

.scene-item:hover,
.scene-item-active {
  border: solid 3px#2783f2;
}

.option-box {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
}

.option-switch {
  position: absolute;
  display: flex;
  display: -webkit-flex;
  top: 6px;
  right: 4px;
  width: 22px;
  height: 12px;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  border-radius: 2px;
  opacity: 0.4;
  z-index: 4;
}
.option-switch:hover {
  opacity: 0.8;
}

.option-switch i {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 1.5px;
  background: #ffffff;
}

.option {
  display: none;
  width: 30%;
  height: 0%;
  float: right;
  margin-top: 18px;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 12%;
}

.option i {
  display: flex;
  display: -webkit-flex;
  justify-content: space-evenly;
  align-items: center;
  color: #fff;
  font-size: large;
  color: #ffb822;
  margin: 10% auto;
}

.option .icon-god-editor {
  font-size: 10px;
  color: #22b9ff;
}

.scene-item-bottom {
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.name {
  color: #fff;
  display: inline-block;
  text-align: center;
  height: 16px;
  line-height: 16px;
  font-family: FZLTHJW--GB1-0;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 768px) {
  #model-scene {
    width: 100%;
    left: 0;
    top: 0;
    height: fit-content;
    overflow-y: hidden;
    padding: 4.5px 10px;
  }

  .scene-item-box {
    height: 75px;
  }

  .scene-list {
    width: 100%;
    align-items: flex-start;
    overflow: hidden;
    height: fit-content;
  }

  .scene-list::-webkit-scrollbar-thumb:horizontal {
    background-color: transparent;
  }

  .scene-item-top {
    height: 100%;
  }

  .scene-item,
  .scene-item-active {
    width: 75px;
    height: 75px;
    border: 1.5px solid rgb(255, 255, 255, 0.4);
  }

  .scene-item:hover,
  .scene-item-active {
    border: 1.5px solid#2783f2;
  }

  .scene-item-bottom {
    height: 20px;
  }

  .name {
    font-size: 10px;
    font-weight: light;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
